import Vue from 'vue'

export default Vue.extend({
  template: `
    <div class="custom-header">
        <span class="custome-header-title">{{ life }}-year</span>
        <span class="custome-header-title">({{ value }})</span>
    </div>
`,

  data() {
    return {
      value: undefined,
      life: undefined,
    }
  },

  created() {
    this.value = this.params.displayName
    this.life = this.params.life
  },
})
